import { render, staticRenderFns } from "./bamanagement.vue?vue&type=template&id=37f3bd60"
import script from "./bamanagement.vue?vue&type=script&lang=js"
export * from "./bamanagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports